import React from 'react'
import { Container, Image } from 'react-bootstrap';

import Headshot from '../../../../assets/img/headshot.png'

const Landing = () => {
    return (
        <header className='text-center text-white bg-primary pt-3'>
            <Container fluid className='pt-5 text-secondary'>
                <Image roundedCircle fluid className='headshot-ring d-block mx-auto mb-5' style={{maxWidth: '220px'}} src={Headshot} alt='Portrait of Maxim Kapelina'/>
                <h1>Maxim Kapelina</h1>
                <hr className='star-dark mb-0' />
                <h2 className='pb-2'>Building AI-Powered Systems With Real User Value</h2>
                <h4 className='pb-4'>Artificial Intelligence - Machine Learning - Web Engineering</h4>
            </Container>
        </header>
    )
}

export default Landing;